import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

export function validateEmail(c: FormControl) {
  const EMAIL_REGEXP = /^[a-zA-Z0-9._\-\+]+@[a-zA-Z0-9._\-]+\.[a-zA-Z]{2,24}$/;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validEmail: {
      valid: false
    }
  };
}

@Directive({
  selector: '[validEmail][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useValue: validateEmail, multi: true}
  ]
})
export class JbEmailValidator {
}



// WEBPACK FOOTER //
// ./src/app/form/validators/email.validator.ts